import Vue from "vue";
import Vuex from "vuex";
import api from "@/api/apis.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    firstLoad: true,
    loading: false,
    /* 從首頁進入最新消息頁，給ID判斷自動開啟modal */
    newsId: "",
    /* 類別資料 */
    categories: {
      classType: [], // SYS_CLASSTYPE - 工藝類別
      teachingResult: [], // SYS_TEACHING_RESULT - 教學成果類別
    },
  },
  mutations: {
    SETFIRSTLOAD(state, payload) {
      state.firstLoad = payload;
    },
    SETLOADING(state, payload) {
      state.loading = payload;
    },
    SETNEWSID(state, payload) {
      state.newsId = payload;
    },
    SETCATEGORIES(state, { type, data }) {
      state.categories[type] = data;
    },
  },
  actions: {
    async fetchCategories({ commit }) {
      try {
        // 獲取 SYS_CLASSTYPE
        const classTypeRes = await api.getCategorysList({
          TypeId: 'SYS_CLASSTYPE',
          page: 1,
          limit: 50,
        });
        if (classTypeRes.data.data) {
          const processedData = classTypeRes.data.data.map(item => {
            const copyItem = JSON.parse(JSON.stringify(item));
            copyItem.description = JSON.parse(copyItem.description);
            return copyItem;
          });
          commit('SETCATEGORIES', { type: 'classType', data: processedData });
        }

        // 獲取 SYS_TEACHING_RESULT
        const teachingResultRes = await api.getCategorysList({
          TypeId: 'SYS_TEACHING_RESULT',
          page: 1,
          limit: 50,
        });
        if (teachingResultRes.data.data) {
          const processedTeachingData = teachingResultRes.data.data.map(item => {
            const copyItem = JSON.parse(JSON.stringify(item));
            copyItem.description = JSON.parse(copyItem.description);
            return copyItem;
          });
          commit('SETCATEGORIES', { type: 'teachingResult', data: processedTeachingData });
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },
  },
  modules: {},
});
